import React from "react";
import { Container, Tag, Data, Unit, Hint, IconWrap } from "./styles";

const StatCard = ({ tag, data, unit, hint, icon, accent = "zinc" }) => {
  const text = typeof data === "string" ? data : String(data ?? "");

  return (
    <Container $accent={accent} title={hint}>
      {icon && <IconWrap aria-hidden>{icon}</IconWrap>}

      <Tag>{tag}</Tag>

      <Data>
        <span className="value">{text || "N/A"}</span>
        {unit && <Unit>{unit}</Unit>}
      </Data>

      <Hint>{hint}</Hint>
    </Container>
  );
};

export default StatCard;
